import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { ErrorInfo } from '../../types';

interface ErrorDisplayProps {
  error: ErrorInfo;
  onRetry?: () => void;
}

export default function ErrorDisplay({ error, onRetry }: ErrorDisplayProps) {
  return (
    <div 
      role="alert"
      className="p-4 bg-bubblegum-50 text-bubblegum-700 rounded-lg flex items-start space-x-3"
    >
      <AlertTriangle className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <h3 className="font-medium mb-1">{error.code}</h3>
        <p className="text-sm">{error.message}</p>
        {error.details && (
          <p className="text-sm mt-1 text-bubblegum-600">{error.details}</p>
        )}
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-2 flex items-center space-x-2 text-sm font-medium hover:text-bubblegum-800"
          >
            <RefreshCw className="h-4 w-4" />
            <span>Try Again</span>
          </button>
        )}
      </div>
    </div>
  );
}